import { authHeader, config } from '../_helpers';

export async function getReportingLocations() {
  try {
    const response = await fetch(config.apiUrl + '/api/getlist/reportinglocation', {
      headers: authHeader(),
    });
    if (!response.ok) return [];
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function getCrewsForBase(baseId) {
  if (!baseId) return [];
  try {
    const response = await fetch(config.apiUrl + '/api/resources/by-base/' + baseId, {
      headers: authHeader(),
    });
    const data = await response.json();
    return data.success ? data.data : [];
  } catch {
    return [];
  }
}
